import { render, staticRenderFns } from "./ReportKeyWords.vue?vue&type=template&id=4211f8dc&scoped=true&"
import script from "./ReportKeyWords.vue?vue&type=script&lang=js&"
export * from "./ReportKeyWords.vue?vue&type=script&lang=js&"
import style0 from "./ReportKeyWords.vue?vue&type=style&index=0&id=4211f8dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4211f8dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
